import $ from 'jquery';

/**
 * @param {{
 * render: string
 * }} apiParams
 * @returns {JQuery.jqXHR}
 */
const loadReCaptchaScript = (apiParams) => {
	      const apiUrlSearchParams = new URLSearchParams({
			      'render': 'explicit',
			      ...apiParams
		      })
		      .toString();
	
	      return $.getScript(
		      `https://www.google.com/recaptcha/api.js?${apiUrlSearchParams}`
	      );
      },
      /**
       * @param {{
       * loadParams?: {render: string},
       * renderParams: Object
       * }} params
       * @returns {Promise}
       */
      renderFirstReCaptcha = async ({loadParams, renderParams}) => {
	      try {
		      await loadReCaptchaScript(loadParams);
		
		      window.grecaptcha.ready(() => {
			      window.grecaptcha.render(
				      renderParams.element,
				      renderParams.params
			      );
		      });
	      } catch (err) {
		      console.error(err);
	      }
      };

export {
	renderFirstReCaptcha
};